import React, { useState } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`
  };
}

const styles = theme => ({
  container: {
    perspective: "50px"
  },
  cardImage: {
    height: "auto",
    width: "200px",
    backgroundColor: "white",
    padding: "1rem",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    "&:hover": {
      cursor: "pointer"
    }
  },
  paper: {
    position: "absolute",
    width: theme.spacing.unit * 50,
    maxWidth: "100%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    outline: "none"
  },
  focusedImage: {
    maxWidth: "100%"
  }
});

function Card(props) {
  const { classes } = props;
  const [open, setOpen] = useState(false);
  const [rotateX, setRotateX] = useState(0);
  const [rotateY, setRotateY] = useState(0);
  const [scale, setScale] = useState(1);

  let counter = 0;
  let updateRate = 10;
  const isTimeToUpdate = function() {
    return counter++ % updateRate === 0;
  };

  const onCardClicked = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [centerX, setCenterX] = useState(0);
  const [centerY, setCenterY] = useState(0);
  const [baseWidth, setBaseWidth] = useState(0);
  const [baseHeight, setBaseHeight] = useState(0);
  const onMouseEnter = e => {
    const bounds = e.target.getBoundingClientRect();
    setCenterX(bounds.left + bounds.width / 2);
    setCenterY(bounds.top + bounds.height / 2);
    if (baseHeight === 0 || baseWidth === 0) {
      setBaseWidth(bounds.width);
      setBaseHeight(bounds.height);
    }
  };
  const onMouseMove = e => {
    if (isTimeToUpdate) {
      const x = (e.clientX - centerX) / baseWidth;
      const y = (e.clientY - centerY) / baseHeight;

      if (centerX !== 0 && centerY !== 0) {
        setRotateX(x.toFixed(2));
        setRotateY(y.toFixed(2));
      }
    }
    setScale(1.07);
  };
  const onMouseOut = e => {
    setRotateX(0);
    setRotateY(0);
    setScale(1);
  };

  return (
    <div id="container" className={classes.container}>
      <img
        className={classes.cardImage}
        src={`${process.env.PUBLIC_URL}/${props.path}`}
        alt={props.name}
        onClick={onCardClicked}
        onMouseMove={onMouseMove}
        onMouseOut={onMouseOut}
        onMouseEnter={onMouseEnter}
        style={{
          transform: `rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(${scale}, ${scale}, ${scale})`,
          transition: "transform 0.25s"
        }}
      />
      <Modal open={open} onClose={handleClose}>
        <div style={getModalStyle()} className={classes.paper}>
          <img
            className={classes.focusedImage}
            onClick={handleClose}
            src={`${process.env.PUBLIC_URL}/${props.path}`}
            alt={props.name}
          />
        </div>
      </Modal>
    </div>
  );
}

Card.propTypes = {
  classes: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};

export default withStyles(styles)(Card);
